import { getLangMap } from "@/utils/getLangMap.ts";
import { homeAtom } from "@/atoms/home";
import { rahuKaalAtom, todayDataAtom } from "@/atoms/rahuKaal";

export default function RahuKaalDefault() {
  const homeData = useAtomValue(homeAtom);
  const data = useAtomValue(rahuKaalAtom);
  const todayData = useAtomValue(todayDataAtom);
  const lan = getLangMap();
  const { $t } = useTranslate();
  const { pathname } = useLocation();
  const fetchRahuKaalData = useSetAtom(homeAtom);
  useEffect(() => {
    fetchRahuKaalData(pathname);
  }, []);
  // 添加一个转换时间格式的辅助函数
  const formatTimeWithAMPM = (time: string) => {
    if (!time) return "";

    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours, 10);

    if (hour >= 12) {
      return `${hour > 12 ? hour - 12 : hour}:${minutes} PM`;
    } else {
      return `${hour === 0 ? 12 : hour}:${minutes} AM`;
    }
  };
  // 添加一个格式化日期的辅助函数
  const formatDate = (epochDate: string) => {
    if (!epochDate) return "";

    const date = new Date(epochDate);
    const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const weekday = weekdays[date.getDay()];
    const month = months[date.getMonth()];
    const day = date.getDate().toString().padStart(2, "0"); // 确保两位数
    const year = date.getFullYear();

    return `${weekday}, ${month} ${day}, ${year}`;
  };
  return (
    <div className="px-16">
      <div className="mt-20 mb-16 ml-0">{formatDate(todayData?.EpochDate)}</div>
      <WeatherContent className="bg-[var(--app-bg-08)] p-16 rounded-10 backdrop-blur-10 mb-20">
        <div className="text-18 color-[var(--app-text-04)] mb-50">{$t("title65")}</div>
        <div className="center gap-x-20 mb-50">
          <span className="text-24">{formatTimeWithAMPM(todayData?.rahu_kaal_start)}</span>
          <span>{$t("title69")}</span>
          <span className="text-24">{formatTimeWithAMPM(todayData?.rahu_kaal_end)}</span>
        </div>
        <div className="flex justify-start items-center gap-x-10">
          <div className="flex-[1] flex flex-col justify-start items-center gap-y-10">
            <div className="font-400">{$t("title12")}</div>
            <div className="font-bold">{formatTimeWithAMPM(todayData?.Sun?.Rise)}</div>
          </div>
          <div className="flex-[1] flex flex-col justify-start items-center gap-y-10">
            <div className="font-400">{$t("title13")}</div>
            <div className="font-bold">{formatTimeWithAMPM(todayData?.Sun?.Set)}</div>
          </div>
          <div className="flex-[1] flex flex-col justify-start items-center gap-y-10">
            <div className="font-400">{$t("title14")}</div>
            <div className="font-bold">{formatTimeWithAMPM(todayData?.Moon?.Rise)}</div>
          </div>
          <div className="flex-[1] flex flex-col justify-start items-center gap-y-10">
            <div className="font-400">{$t("title15")}</div>
            <div className="font-bold">{formatTimeWithAMPM(todayData?.Moon?.Set)}</div>
          </div>
        </div>
      </WeatherContent>

      <div className="mb-16">
        {$t("title68")}&nbsp;{homeData?.data.info?.name}
        {homeData?.data.info?.name && homeData?.data.info?.area?.LocalizedName
          ? ["pt", "vi"].includes(lan?.toLocaleLowerCase?.())
            ? ", "
            : ","
          : ""}
        {homeData?.data.info?.area?.LocalizedName}
      </div>

      <WeatherContent className="bg-[var(--app-bg-08)] p-16 rounded-10 backdrop-blur-10 p-x-0!">
        {data
          ?.filter?.((item: any) => item.Week !== "Today")
          ?.map?.((item: any, index: any) => (
            <div
              key={index}
              className={`flex justify-start items-center px-16 py-8 ${index % 2 === 0 ? "bg-[var(--app-bg-20)]" : ""}`}
            >
              <div className="flex-[2] flex flex-col justify-center items-stretch">
                <span>{item.Week}</span>
                <span>
                  {item.EpochDate.split(" ")[0].split("-")[2]}/{item.EpochDate.split(" ")[0].split("-")[1]}
                </span>
              </div>
              <div className="flex-[3] flex justify-between items-center">
                <span>{formatTimeWithAMPM(item.rahu_kaal_start)}</span>
                <span>{$t("title70")}</span>
                <span>{formatTimeWithAMPM(item.rahu_kaal_end)}</span>
              </div>
            </div>
          )) ?? null}
      </WeatherContent>
    </div>
  );
}
